export default {
    getForum: '/api/forum',
    getHome: '/api/home',
    getVideo: '/api/video'
  }
  